export class CustomParamsTrackingNumberAndTypeControlModel {
  TrackingNum: string;
  TrackingTypeID: number;
}
